// @ts-ignore
import { html, TemplateResult } from 'lit';
import { OutlineCard } from 'src/components/base/outline-card/outline-card';
// @ts-ignore
import { customElement, property } from 'lit/decorators.js';
// @ts-ignore
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './idb-expandable-card.css.lit';
import '../idb-icon/idb-icon';

/**The IDB expandable card component.
 * @element idb-expandable-card
 * @extends OutlineCard
 * @property expanded — Value to collapse or expand the card content
 * @property backgroundColor — Dynamic value to change the background color of the card
 * @property textColor — Dynamic value to change the text color of the card content
 * @slot title - The title slot for card content
 * @slot subtitle - The subtitle slot for card content
 * @slot acronym - The acronym slot for card content
 * @slot summary - The summary slot for card content
 * @slot example - The example slot for card content
 * @slot cta-link - The cta-link slot for card content
 */
@customElement('idb-expandable-card')
export class IdbExpandableCard extends OutlineCard {
  static styles = [componentStyles];

  @property({ type: Boolean })
  expanded: boolean = false;

  @property({ type: Boolean, attribute: 'is-expanded' })
  isExpanded: boolean = false;

  @property({ type: Boolean, attribute: 'is-catalog-card' })
  isCatalogCard: boolean = false;

  @property({ type: String, attribute: 'background-color' })
  backgroundColor: string = '#BBDDF2';

  @property({ type: String, attribute: 'text-color' })
  textColor: string = '#00374E';

  /**
   * Binding Properties to CSS Variables
   */
  updated(changedProperties: Map<string, any>) {
    if (changedProperties.has('backgroundColor')) {
      // @ts-ignore
      this.style.setProperty('--background-color', this.backgroundColor);
    }
    if (changedProperties.has('textColor')) {
      // @ts-ignore
      this.style.setProperty('--text-color', this.textColor);
    }
  }


  private toggleCardContent() {
    if (!this.isExpanded) {
      // @ts-ignore
      const container = this.shadowRoot?.querySelector('.idb-expandable-card__description-container') as HTMLElement;

      if (this.expanded) {
        const height = container.scrollHeight;
        container.style.height = `${height}px`;
        requestAnimationFrame(() => {
          container.style.height = '0px';
        });
      } else {
        container.style.height = '0px';
        const height = container.scrollHeight;
        requestAnimationFrame(() => {
          container.style.height = `${height}px`;
        });
      }

      this.expanded = !this.expanded;
    }
  }


  render(): TemplateResult {
    const classes = {
      'idb-expandable-card__content': true,
      'bg-hover': !this.isExpanded,
    };

    return html`
      <article class="${classMap(classes)}">
        <header @click="${this.toggleCardContent}">
          <slot class="idb-expandable-card__title" name="title"></slot>
        </header>
        <section class="idb-expandable-card__description-container">
          <slot class="idb-expandable-card__subtitle" name="subtitle"></slot>
          <slot class="idb-expandable-card__acronym" name="acronym"></slot>
          <slot class="idb-expandable-card__summary" name="summary"></slot>
          <slot class="idb-expandable-card__example" name="example"></slot>
          ${(!this.isExpanded) ? this.ctaTemplate(): ''}
        </section>
        ${(this.isExpanded) ? this.ctaTemplate(): ''}
      </article>
		`;
  }

  ctaTemplate(): TemplateResult {
    return html`
      <footer class="idb-expandable-card__cta-link">
        <slot name="cta-link"></slot>
        <idb-icon
          icon="chevrons-right"
          size="1em"
          color="currentColor"
          stroke-width="2"
          style=" margin-left: 6px; margin-top: 3px;"
        ></idb-icon>
      </footer>
    `;
  }
}
